export default __webpack_public_path__ + "static/media/painter.ae52ff61.jpg";